export const icons = {
  group: require('./group.png'),
  userInfo: require('./user-info.png'),
  CheckFill: require('./check.png'),
  Heart: require('./heart.png'),
  Upload: require('./upload.png'),
  Download: require('./download.png'),
  Play: require('./play.png'),
  Info: require('./info.png'),
  Law_firm: require('./Law_firm.png'),
  Solicitor: require('./solicitor.png'),
  Barrister: require('./barister.png'),
  Chamber: require('./chamber.png'),
  QuestionMark: require('./question_mark.png'),
  light: {
    question_mark: require('./question_mark.png'),
    heart: require('./heart.png'),
    phone: require('./phone_light.png'),
  },
  dark: {
    question_mark: require('./question_mark_dark.png'),
    heart: require('./heart_dark.png'),
    phone: require('./phone_dark.png'),
  },
  blue: {
    heart: require('./heart_blue.png'),
  },
}
